import React from "react"
import styled from "styled-components"
import { useOrbit3DStore } from "../state/orbit3DStore"
import Title from "@common/ui/Title"

export type ViewLayoutHandle = {
  on: () => void
  off: () => void
}

export const ViewUI = ({ pointsMapped }) => {
  return (
    <>
      {pointsMapped.map((info, index) => (
        <ViewLayout key={index} index={index} text={info.text} />
      ))}
    </>
  )
}

const ViewLayout = ({ text, index }) => {
  const { title, subTitle, body } = text
  const [active, setActive] = React.useState(false)
  const activeView = useOrbit3DStore((s) => s.activeView)

  React.useEffect(() => {
    if (activeView[0] === index) {
      setActive(true)
    } else {
      setActive(false)
    }
  }, [activeView])

  return (
    <OrbitInfo
      style={{
        opacity: active ? 1 : 0,
      }}
    >
      <Title main={title} sub={subTitle} body={body} align="right" />
    </OrbitInfo>
  )
}

const OrbitInfo = styled.div`
  z-index: 2;
  transition: opacity 0.5s;
  pointer-events: none;
  position: absolute;
  bottom: 0;
  right: 0;
  margin: 0 2rem;
  font-size: 7.5rem;
`

export default ViewUI
